/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type FC } from 'react';

import cls from 'classnames';
import { type TableProps, Table } from '@coze-arch/coze-design';

import styles from './index.module.less';

export const AuthTable: FC<
  TableProps & {
    size?: 'small' | 'default';
    type?: 'primary' | 'default';
  }
> = ({
  wrapperClassName,
  tableProps,
  size = 'default',
  type = 'default',
  ...rest
}) => (
  <Table
    {...rest}
    wrapperClassName={cls(styles['table-wrap'], wrapperClassName)}
    tableProps={{
      ...tableProps,
      className: cls(
        styles['table-content'],
        tableProps?.className,
        styles[size],
        styles[type],
      ),
    }}
  />
);
